import React from 'react';
import Layout from '@/common/Layout';
import MaterialLabelPage from './components/MaterialLabelPage';

const Label = () => {
  return (
    <>
      <Layout sider={false} menuItems={false}>
        <MaterialLabelPage />
      </Layout>
    </>
  );
};

export default Label;
